import script from "./MbPerview.vue?vue&type=script&lang=tsx"
export * from "./MbPerview.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__